// yeah this code gets kinda gross lol - ianr
import getCups from '../../../functions/getCups';
import trackToString from '../../../functions/trackToString';
import DisplayCups from '../../DisplayCups';
import Button from '../../Button/Button';
import { useLayoutEffect, useState } from 'react';
import DisplayCupTracks from '../../track-components/DisplayCupTrackSelect';
import cupToString from '../../../functions/cupToString';
import DisplayYourCup from '../../track-components/DisplayYourCup';
import DisplayCupBrowse from '../../track-components/DisplayCupBrowse';

import "./CupBuilder.css";
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import { addDoc, collection, doc, updateDoc, arrayUnion, deleteDoc, getFirestore, serverTimestamp } from 'firebase/firestore';
import { initializeApp } from 'firebase/app';
import { app } from '../../../functions/firebaseInit';
import SmallPop from '../../pops/SmallPop';
// import getRandomTrack from '../../../functions/getRandomTrack';

export default function CupBuilder() {

    const [width, auth] = useOutletContext();
    const navigate = useNavigate();
    const location = useLocation();
    const firestore = getFirestore(initializeApp(app));

    const cups = getCups();
    const [shownCup, setShownCup] = useState("mushroom");

    // track data for user's cup, use loader if signing in/up after building a cup
    const [yourCup, setYourCup] = useState(location.state?.yourCup ? location.state.yourCup
        : [null, null, null, null]);

    const [cupName, setCupName] = useState("")

    const [smallPop, setSmallPop] = useState(location.state?.deletingAccount ?
        { text: "Account deleted." } : null);
    
        useLayoutEffect(() => {

        const timeout = setTimeout(() => {
            setSmallPop(false);
        }, 3500);

        return () => clearTimeout(timeout);

    }, [smallPop]);

    /**
     * Adds a track object to the user's cup.
     * @param {*} track - a number from a selected track or a Track object
     */
    const addTrack = (track) => {
        const newCup = [...yourCup];
        const addTrack = typeof track === "number" ? 
            cups.get(shownCup).tracks[track] : track;    
        addTrack.origin ??= null;

        if (newCup.indexOf(null) !== -1 && !hasTrack(yourCup, addTrack)) {
            newCup[newCup.indexOf(null)] = {
                ...addTrack,
                cup: shownCup,
                emblem: cups.get(shownCup).emblem,
                originIndex: track,
                origin: !addTrack.origin ? null : addTrack?.origin
            };
            setYourCup([...newCup]);

            if (newCup.indexOf(null) === -1) {
                window.scrollTo(0, 0);
            }
        } else {
            setSmallPop({ text: "You have already selected this track." });
        }
    }

    /**
     * Checks if a given cup array has a track in it already.
     * @param {Array} cup - an array of cup objects
     * @param {Object} track - a track object 
     * @returns if the passed cup has the passed track in it or not.
     */
    const hasTrack = (cup, track) => {
        for (let i = 0; i < yourCup.length; i++) {
            if (cup[i]?.name === track.name && cup[i].origin === track.origin) {
                return true;
            }
        }
        return false;
    }

    /**
     * Removes the last selected track from the user's cup.
     */
    const undo = () => {
        const goBack = yourCup.indexOf(null);
        const newCup = [...yourCup];
        newCup[goBack - 1] = null;
        setYourCup(newCup);
    }

    /**
     * Resets the user's cup back to empty.
     */
    const reset = () => {
        setYourCup([null, null, null, null]);
    }

    // is upload in progress?
    const [upload, setUpload] = useState(false);

    /**
     * Uploads the user's created track to Firestore database.
     */
    async function fbUpload() {
        setUpload(true);
        // console.log("UPLOAD ATTEMPT");

        // check if cup has any booster course pass tracks
        const hasDLC = (tracks) => {
            for (const track in tracks) {
                if (isDLC(tracks[track].cup)) {
                    return true;
                }
            }
            return false;
        }

        // returns if track is DLC for query purposes
        const isDLC = (cup) => {
            return cup === "golden-dash" || cup === "lucky-cat" || cup === "turnip" || cup === "propeller"
                || cup === "rock" || cup === "moon" || cup === "fruit" || cup === "boomerang"
                || cup === "feather" || cup === "cherry" || cup === "acorn" || cup === "spiny";
        }

        // actual firestore datapoints, track info saved locally (getTrackData() converts
        // this information to visual track information. (functions folder) )
        const tracks = [
            { cup: yourCup[0].cup, originIndex: yourCup[0].originIndex },
            { cup: yourCup[1].cup, originIndex: yourCup[1].originIndex },
            { cup: yourCup[2].cup, originIndex: yourCup[2].originIndex },
            { cup: yourCup[3].cup, originIndex: yourCup[3].originIndex }
        ];

        // track names if i query by name eventually
        const trackNames = [...yourCup.map((element) => { return trackToString(element) })];

        // upload cup document and save new ref to user doc
        await addDoc(collection(firestore, "cups"), {
            containsDLC: hasDLC(yourCup),
            creator: auth.currentUser.uid,
            tracks: tracks,
            trackList: trackNames,
            timestamp: serverTimestamp(),
            cupName: cupName
        })
            .then(async (newDoc) => {
                console.log(newDoc.id);
                const userdoc = doc(firestore, "users", auth.currentUser.uid);
                await updateDoc(userdoc, { cups: arrayUnion(newDoc) })
                    .then(() => setSmallPop(
                        {
                            text: "Cup uploaded",
                            link: {
                                to: `/browse/cup/${newDoc.id}`,
                                text: "View Cup Page"
                            },
                        })
                    )
                    .catch((e) => {
                        // delete new doc cup if user cannot be updated
                        setSmallPop({ text: `Error updating user page: ${e.message}` });
                        deleteDoc(newDoc);
                        setUpload(false);
                    });
            })
            .catch((error) => {
                setSmallPop({ text: `There was an error posting your cup: ${error.message}` });
                setUpload(false);
            });
    }

    return <div id="main-container">
        <div
            id="track-maker"
            className='track-modal'
            style={{ display: yourCup.indexOf(null) >= 0 ? "flex" : "none" }}
        >

            <div id="ui-header">
                <Button
                    text="Undo"
                    icon={require("../../../assets/icons/icons8-undo-50.png")}
                    onClick={() => undo()}
                />

                <h2>{`Select track #${yourCup.indexOf(null) + 1}/${yourCup.length}`}</h2>

                {/* <Button
                    text="Add random track"
                    onClick={() => addTrack(getRandomTrack())}
                /> */}

                <Button
                    text="Clear"
                    icon={require("../../../assets/icons/icons8-waste-50.png")}
                    onClick={() => reset()}
                />
            </div>

            <div>
                <h3>Your Custom Cup</h3>
                <DisplayYourCup
                    yourCup={true}
                    selectTrack={yourCup.indexOf(null)}
                    tracks={yourCup}
                    width={width}
                />
            </div>

            <DisplayCups
                cups={cups}
                shownCup={shownCup}
                setShownCup={setShownCup}
                width={width}
            />


            <div>
                <h3>{cups.get(shownCup).display} Cup</h3>
                <DisplayCupTracks
                    cup={shownCup}
                    tracks={cups.get(shownCup).tracks}
                    yourCup={false}
                    onAddTrack={addTrack}
                    width={width}
                    selectTrack={1}
                />
            </div>

        </div>

        <div
            id="cup-complete"
            className='track-modal'
            style={{ display: yourCup.indexOf(null) === -1 ? "flex" : "none" }}
        >
            <h2>Cup Complete</h2>

            <h3 style={{ textAlign: "center", marginBottom: 0}}>
                Name your cup! (optional)
            </h3>
            <p style={{ marginTop: 0 }}>
                <i>This cannot be changed later</i>
                <br/> <i>(Eventually it can be)</i>
            </p>

            <DisplayCupBrowse
                tracks={yourCup}
                width={width}
                editName={true}
                editedName={setCupName}
            />

            <div id="cupcomplete-buttons">
                <Button
                    text="Restart"
                    icon={require("../../../assets/icons/icons8-reset-50.png")}
                    onClick={() => {
                        reset();
                        setShownCup("mushroom");
                        window.scrollTo(0, 0);
                        setUpload(false);
                    }}
                />


                <Button
                    text="Copy Text"
                    icon={require("../../../assets/icons/icons8-share-50.png")}
                    onClick={() => {
                        navigator.clipboard.writeText("My Custom #MK8DX Cup\n" +
                            cupName + "\n" + cupToString(yourCup) +
                            "https://mk8dx-cup-builder.web.app/");
                        setSmallPop({ text: "Copied cup to clipboard! " })
                    }}
                />

                {
                    auth.currentUser?.uid ? <Button
                        text="Post Cup"
                        icon={require("../../../assets/icons/icons8-upload-50.png")}
                        onClick={() => fbUpload()}
                        disabled={upload}
                    /> :
                        <Button
                            text="Sign in to post"
                            icon={require("../../../assets/icons/profile-black.png")}
                            onClick={() => navigate("/signin", { state: { yourCup: yourCup } })}
                        />
                }
            </div>

        </div>

        {
            smallPop &&
            <SmallPop
                text={smallPop.text}
                link={smallPop.link}
            />
        }
    </div>
}